import React, { ComponentPropsWithoutRef, FC } from "react";
import cn from "classnames";

interface Props extends ComponentPropsWithoutRef<"div"> {}

export const Stackable: FC<Props> = ({ className, ...props }) => (
  <div className={cn("top-0 w-full xl:sticky xl:py-6", className)} {...props} />
);
